import React, { useEffect } from 'react';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import propTypes from 'prop-types';

function BookshelfFrame({ className, setLocalLoader }) {
  useEffect(() => {
    setLocalLoader(false);
  }, []);

  return (
    <div className={className}>
      <iframe
        title='Off-Market Bookshelf'
        src={'https://book928893.publuu.com/?embed'}
        allowFullScreen={true}
        width='100%'
      />
    </div>
  );
}

BookshelfFrame.propTypes = {
  className: propTypes.string,
  setLocalLoader: propTypes.func
};

export default withLocalLoader(BookshelfFrame, true, 'Bookshelf', 'Bookshelf');
